import { Box } from "@mui/joy";
import Color from "color";
import { useLayoutEffect, useRef, useState } from "react";

import { Route } from "../../core/types";
import { RoutePinText } from "../Map/MapRoutePinSvg";

const RoutePin = ({ route }: { route: Partial<Route> }) => {
  const bgColor = route.colors?.split(":")[0] || "#FFFFFF";
  const fgColor = Color(bgColor).isDark() ? "#FFFFFF" : "#000000";

  const [fontSize, setFontSize] = useState(14);
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      const textLength = ref.current.innerText.length;
      if (textLength > 3) {
        setFontSize(10);
      } else if (textLength === 3) {
        setFontSize(12);
      } else {
        setFontSize(14);
      }
    }
  }, [route]);

  return (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        height: 24,
        border: "2px solid",
        borderColor: "#00000033",
        borderRadius: route.climbType === "BOULDER" ? "50%" : "2px",
        backgroundColor: bgColor,
        fontSize,
        color: fgColor,
        letterSpacing: "-0.01em",
      }}
    >
      <RoutePinText route={route} />
    </Box>
  );
};

export default RoutePin;
